import { useSelector } from 'react-redux';
import { keepPreviousData } from '@tanstack/react-query';

import { SystemTraits } from '@playq/octopus2-analytics';
import { PermModule } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { appToolkit } from '/store';
import { useModulePermissions } from '/hooks';

export const appTraitsRetrieveKeys: unknown[] = ['app', 'traits', 'retrieve'];
export const appRetrieveSystemTraitsKeys: unknown[] = appTraitsRetrieveKeys.concat('system');

const emptyArray: [] = [];

export const useRetrieveSystemTraits = (
  options?: IUseQueryOptionsExtended<SystemTraits | undefined, GenericFailure | Error>
) => {
  const appID = useSelector(appToolkit.selectors.appID);

  const { canRead } = useModulePermissions(PermModule.AnalyticsTraits);

  const res = useEitherQuery(
    appRetrieveSystemTraitsKeys.concat(appID),
    () => {
      if (appID !== undefined) {
        return services2.appTraitsService.retrieveSystemTraits(appID);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
      enabled: options?.enabled !== false && canRead,
    }
  );

  return { ...res, groups: res.data?.groups || emptyArray };
};
